type Props = {
    endDate: string;
    startDate: string;
};

export const getAgreementDaysLeft = ({ startDate, endDate }: Props) => {
    if (!startDate || !endDate) {
        return 0;
    }

    const parseDate = (dateString: string): Date => {
        const [day, month, year] = dateString.split('.').map(Number);

        return new Date(year, month - 1, day); // Месяцы в JS начинаются с 0
    };

    try {
        const start = parseDate(startDate);
        const end = parseDate(endDate);

        const diffInMs = end.getTime() - start.getTime();

        const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));

        return diffInDays;
    } catch (error) {
        console.error('Invalid date format', error);

        return 0;
    }
};
